
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/influencer-affiliates",
      function () {
        return require("private-next-pages/influencer-affiliates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/influencer-affiliates"])
      });
    }
  